import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';
import { SERVICE_REQUEST_TIMEOUT_MS } from 'garaje/utils/catch-service-error';

export default class MapsAdapter extends ApplicationAdapter {
  host = config.mapsHost;
  namespace = 'a/maps/api/v1';

  ajaxOptions(url, type, options = {}) {
    const hash = super.ajaxOptions(url, type, options);
    // Reads only: timing out a slow write invites a retry of an operation the
    // server may still commit
    if (type === 'GET') {
      hash.timeout = SERVICE_REQUEST_TIMEOUT_MS;
    }
    return hash;
  }
}
